import { render } from "./PrintProductionPage.vue?vue&type=template&id=ea953056&scoped=true&ts=true"
import script from "./PrintProductionPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrintProductionPage.vue?vue&type=script&setup=true&lang=ts"

import "./PrintProductionPage.vue?vue&type=style&index=0&id=ea953056&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea953056"],['__file',"resources/js/vue/domain/admin/seg-frame-builder/print-page/PrintProductionPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ea953056"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ea953056', __exports__)) {
    api.reload('ea953056', __exports__)
  }
  
  module.hot.accept("./PrintProductionPage.vue?vue&type=template&id=ea953056&scoped=true&ts=true", () => {
    api.rerender('ea953056', render)
  })

}


export default __exports__